/**
 * SettingsMenu - Settings modal with cache clear functionality
 *
 * Features:
 * - Clear cache & reset app
 * - Modal UI
 */

import { useState } from 'react';
import { Modal } from '../shared/Modal';
import { supabase } from '../../lib/supabase';

export function SettingsMenu() {
  const [isOpen, setIsOpen] = useState(false);

  const handleClearCache = () => {
    console.log('[SettingsMenu] Clearing cache and signing out...');

    // Close modal immediately
    setIsOpen(false);

    // Clear ALL storage immediately FIRST (nuclear option - ensures complete reset)
    console.log('[SettingsMenu] Clearing all storage...');
    localStorage.clear();
    sessionStorage.clear();
    console.log('[SettingsMenu] ✅ All storage cleared');

    // Sign out from Supabase after clearing storage
    console.log('[SettingsMenu] Signing out from Supabase...');
    supabase.auth.signOut({ scope: 'local' }).catch(err => {
      console.error('[SettingsMenu] Error during sign out:', err);
    });

    // Force hard reload with cache busting
    console.log('[SettingsMenu] Reloading app...');
    window.location.href = window.location.origin + window.location.pathname + '?_=' + Date.now();
  };

  return (
    <>
      <button
        className="settings-icon-button"
        onClick={() => setIsOpen(true)}
        title="Settings"
        aria-label="Open settings"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      </button>

      {isOpen && (
        <Modal onClose={() => setIsOpen(false)}>
          <div className="settings-modal-content">
            <h2 className="settings-modal-title">Settings</h2>

            <section className="settings-section">
              <h3 className="settings-section-title">App Data</h3>
              <p className="settings-section-description">
                Clear all stored preferences and reset the app to its initial state.
              </p>
              <button className="danger-button" onClick={handleClearCache}>
                🗑️ Clear Cache & Reset App
              </button>
              <p className="settings-help-text">
                This will remove all stored preferences and return you to the role
                selection screen. Your Supabase account data will not be affected.
              </p>
            </section>

            <section className="settings-section">
              <h3 className="settings-section-title">About</h3>
              <p className="settings-section-description">
                EMDR Sync - Professional bilateral stimulation therapy tool
              </p>
              <div className="settings-info">
                <p className="settings-info-item">
                  <strong>Version:</strong> 1.0.0
                </p>
                <p className="settings-info-item">
                  <strong>Support:</strong>{' '}
                  <a
                    href="mailto:info@emdrsync.io"
                    className="settings-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    info@emdrsync.io
                  </a>
                </p>
              </div>
            </section>
          </div>
        </Modal>
      )}
    </>
  );
}
